// test2094
(2094 && 0);
